import React, { useEffect, useState } from 'react';
import { Button, H1, notify } from '../const';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { walletOption } from '../const';
import styled from 'styled-components';
import { ethers } from 'ethers';
import { creditBalance, signatureLogin } from '../services/ApiServices';
import { useWeb3React } from '@web3-react/core';
import { metamask, walletconnect, translateNum } from '../const';
import { getContract } from '../helpers/contract';
import { tokenContractAbi, getTokenContract } from '../helpers/tokenContract';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRefresh } from '@fortawesome/free-solid-svg-icons';
import { BuyCreditModal } from './BuyCreditModal';
import loading_icon from '../assets/images/loading.gif';
import Close from '../assets/images/hamburger-close.svg';
import moment from 'moment';
import WalletConnectProvider from '@walletconnect/web3-provider';
import Web3 from 'web3';
import { config } from '../environment';
import { useTranslation } from 'react-i18next';
import swal from 'sweetalert';
import WhitelistModal from './WhitelistModal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '635px',
    minWidth: '200px',
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    background: '#80D1E9',
    padding: '40px',
};

const Li = styled.li`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 10px;
    background-color: white;
    height: 56px;
    margin: 15px 0;
    font-weight: 600;
    backdrop-filter: blur(24px);
    border-radius: 12px;
    cursor: pointer;
    @media screen and (max-width: 577px) {
        padding: 0px 15px;
    }
`;
const CloseButton = styled.div`
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 15px;
    right: 15px;
    height: 35px;
    width: 35px;
    border-radius: 50%;
    background-color: #ffd756;
    cursor: pointer;
`;

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    img {
        width: 30px;
        margin-right: 25px;
    }
    p {
        font-family: 'Inter';
        font-weight: 600;
        font-size: 18px;
    }
    @media screen and (max-width: 577px) {
        img {
            width: 25px;
            margin-right: 15px;
        }
        p {
            font-size: 15px;
        }
    }
`;

const CommonText = styled.p`
    font-size: 20px;
    font-weight: 700;
    line-height: 25px;
    @media screen and (max-width: 577px) {
        font-size: 15px;
        line-height: 20px;
    }
`;

const RefreshIcon = styled.div`
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
    height: 30px;
    &.loading {
        animation: rotation infinite 1s linear;
    }
    @keyframes rotation {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

function CreditBalance({ showModal, setShowModal, token, setToken, isMobile }) {
    const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
    const [open, setOpen] = React.useState(false);
    const [web3Account, setWeb3Account] = useState(
        localStorage.getItem('web3Account')
    );
    const [web3Library, setWeb3Library] = useState();
    const [web3Provider, setWeb3Provider] = useState();
    const [isWalletConnect, setIsWalletConnect] = useState();
    const { deactivate } = useWeb3React();
    const [updateTime, setUpdateTime] = useState(new Date());
    const [credits, setCredits] = useState(0);
    const [tamaBalance, setTamaBalance] = useState(0);
    const [transactionLoading, setTransactionLoading] = useState(false);
    const [load, setLoad] = useState(false);
    const [isWhitelistError, setIsWhitelistError] = useState(false);
    const [whitelistError, setWhitelistError] = useState('');

    const onCloseWhitelistModal = () => {
        setIsWhitelistError(false);
        setWhitelistError('');
    };
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const openModal = async (bool) => {
        setShowModal(bool);
    };
    window?.ethereum?.on('accountsChanged', async function (accounts) {
        const address = localStorage.getItem('web3Account')?.toLowerCase();
        address && disconnectWallet(true);
    });

    window?.ethereum?.on('chainChanged', function (chainId) {
        if (`${chainId}` !== process.env.REACT_APP_CHAIN_ID_HEX) {
            disconnectWallet(true);
        }
    });

    const connectMetaMask = async () => {
        function activateInjectedProvider(providerName) {
            const { ethereum } = window;

            let provider;

            if (!ethereum?.providers) {
                console.log(
                    window.ethereum,
                    ethereum.providers,
                    ethereum.isMetaMask
                );
                if (ethereum?.isMetaMask) {
                    console.log(ethereum);
                    provider = ethereum;
                    return provider;
                }
                return undefined;
            }

            // eslint-disable-next-line default-case
            switch (providerName) {
                case 'CoinBase':
                    provider = ethereum.providers.find(
                        ({ isCoinbaseWallet }) => isCoinbaseWallet
                    );
                    break;
                case 'MetaMask':
                    provider = ethereum.providers.find(
                        ({ isMetaMask }) => isMetaMask
                    );
                    console.log('Provider us ', provider);
                    console.log('Providers are ', ethereum.providers);
                    break;
            }

            return provider;
        }

        const provider = activateInjectedProvider('MetaMask');
        if (provider) {
            console.log('window ', provider);
            let isMetamaskSetuped = false;
            await provider
                .request({
                    method: 'eth_requestAccounts',
                })
                .then(() => (isMetamaskSetuped = true))
                .catch(async (err) => {
                    handleClose();
                    notify('User Rejected Requested', 'error');
                    isMetamaskSetuped = false;
                });
            if (
                isMetamaskSetuped &&
                provider.networkVersion !== process.env.REACT_APP_CHAIN_ID
            ) {
                try {
                    await provider
                        .request({
                            method: 'wallet_switchEthereumChain',
                            params: [
                                {
                                    chainId: `${process.env.REACT_APP_CHAIN_ID_HEX}`,
                                },
                            ],
                        })
                        .then()
                        .catch((err) => {
                            handleClose();
                            notify(`User rejected request`, 'error');
                        });
                } catch (switchError) {
                    notify(
                        `Connected network should be ${process.env.REACT_APP_NETWORK}`,
                        'warning'
                    );
                }
            }
            const etherProvider = new ethers.providers.Web3Provider(provider);
            // await window.ethereum
            //     .enable()
            //     .then()
            //     .catch(async (err) => {
            //         handleClose();
            //         notify('User Rejected Requested', 'error');
            //     });
            const signer = etherProvider.getSigner();
            setWeb3Account(await signer.getAddress());
            localStorage.setItem('web3Account', await signer.getAddress());
            setWeb3Library(signer);
            const message = `Welcome to TAMA world!\n\nSign this message to prove you have access to this wallet and have read and agree to the Tamadoge Privacy Policy https://tamadoge.io/privacy-policy/. \nThis won't cost you any Ether.\n\nYour authentication status will reset after 72 hours.\n\nWallet address:\n${await signer.getAddress()}`;
            const signature =
                `${signer.provider._network.chainId}` ===
                    process.env.REACT_APP_CHAIN_ID &&
                (await signer
                    .signMessage(message)
                    .then()
                    .catch(() => {
                        handleClose();
                        notify('User Rejected Signing', 'error');
                    }));

            signature &&
                signatureLogin(await signer.getAddress(), signature, message)
                    .then(async (res) => {
                        setToken(res.data.data.token);
                        localStorage.setItem('token', res.data.data.token);
                        setIsWalletConnect(false);
                        await fetchBalance(
                            res.data.data.token,
                            signer,
                            await signer.getAddress()
                        );
                    })
                    .catch(async (err) => {
                        setWhitelistError(err.response.data.message);
                        setIsWhitelistError(true);
                    });
        } else {
            notify('Install Metamask', 'warning');
            return;
        }
        handleClose();
    };

    // const connectCoinBase = async () => {
    //     // activate(connectors.coinbaseWallet);
    //     // let walletProvider = window.ethereum;
    //     console.log('Coinbase', window.ethereum);
    //     if (window.ethereum) {
    //         const etherProvider = new ethers.providers.Web3Provider(
    //             window.ethereum.isCoinbaseWallet
    //                 ? window.ethereum
    //                 : window.ethereum.providers.find(
    //                       (prov) => prov.isCoinbaseWallet
    //                   )
    //         );
    //         const accounts = await window.ethereum.request({
    //             method: 'eth_requestAccounts',
    //         });
    //         const signer = etherProvider.getSigner();
    //         console.log(signer, 'signer');
    //         // localStorage.setItem('web3Account', await signer.getAddress());
    //         // localStorage.setItem('web3Library', signer);
    //         setWeb3Account(await signer.getAddress());
    //         setWeb3Library(signer);
    //         const message = 'Hello Tama P2E world!';
    //         const signature = await signer.signMessage(message);
    //         const signAddress = await ethers.utils.verifyMessage(
    //             message,
    //             signature
    //         );
    //         signatureLogin(signAddress, signature, message)
    //             .then(async (res) => {
    //                 console.log(res.data.data.token, 'JWT Token');
    //                 setToken(res.data.data.token);
    //                 localStorage.setItem('token', res.data.data.token);
    //                 await fetchBalance(
    //                     res.data.data.token,
    //                     signer,
    //                     await signer.getAddress()
    //                 );
    //             })
    //             .catch(async (err) => {
    //                 console.log(err);
    //             });
    //         // setUserAddress(accounts[0]);
    //         if (signAddress.toLowerCase() === accounts[0].toLowerCase()) {
    //             console.log('User Login');
    //         } else {
    //             console.log('Login failed');
    //         }
    //         handleClose();
    //     }
    // };

    const connectWallectConnect = async () => {
        const provider = new WalletConnectProvider({
            rpc: config.walletConnect,
        });
        const web3 = await new Web3(provider);
        await provider
            .enable()
            .then(async (res) => {
                setWeb3Provider(web3);
            })
            .catch(async (err) => {
                handleClose();
                disconnectWallet(false);
            });

        //  Get Chain Id
        const chainID = await web3.eth.getChainId();

        // if (chainID !== process.env.REACT_APP_CHAIN_ID) {
        //     console.log(
        //         process.env.REACT_APP_CHAIN_ID,
        //         'process.env.REACT_APP_CHAIN_ID'
        //     );
        //     try {
        //         await provider
        //             .request({
        //                 method: 'wallet_switchEthereumChain',
        //                 params: [
        //                     {
        //                         chainId: `0x1`,
        //                         rpcUrl: 'https://mainnet.infura.io/v3/',
        //                     },
        //                 ],
        //             })
        //             .then((res) => console.log(res, 'res'))
        //             .catch((err) => {
        //                 handleClose();
        //                 notify(`User rejected request`, 'error');
        //                 disconnectWallet(false);
        //             });
        //     } catch (switchError) {
        //         console.log(switchError, 'switchError');
        //         if (switchError.code === 4902) {
        //             try {
        //                 await provider.request({
        //                     method: 'wallet_addEthereumChain',
        //                     params: [
        //                         {
        //                             chainId: `${process.env.REACT_APP_CHAIN_ID_HEX}`,
        //                             chainName: `${process.env.REACT_APP_NETWORK}`,
        //                             rpcUrls: [
        //                                 `${process.env.REACT_APP_NETWORK_RPC_URL}`,
        //                             ],
        //                         },
        //                     ],
        //                 });
        //             } catch (addError) {
        //                 handleClose();
        //                 notify(`User rejected request`, 'error');
        //             }
        //         }
        //         notify(
        //             `Connected network should be ${process.env.REACT_APP_NETWORK}`,
        //             'warning'
        //         );
        //     }
        // }

        if (`${chainID}` === process.env.REACT_APP_CHAIN_ID) {
            const etherProvider = new ethers.providers.Web3Provider(provider);
            const signer = etherProvider.getSigner();
            setWeb3Account(await signer.getAddress());
            localStorage.setItem('web3Account', await signer.getAddress());
            setWeb3Library(signer);
            const message = `Welcome to TAMA world!\n\nSign this message to prove you have access to this wallet and have read and agree to the Tamadoge Privacy Policy https://tamadoge.io/privacy-policy/. \nThis won’t cost you any Ether.\n\nYour authentication status will reset after 72 hours.\n\nWallet address:\n${await signer.getAddress()}`;
            const signature = await signer
                .signMessage(message)
                .then()
                .catch(() => {
                    handleClose();
                    notify('User Rejected Signing', 'error');
                    disconnectWallet(false);
                });

            signature &&
                signatureLogin(await signer.getAddress(), signature, message)
                    .then(async (res) => {
                        setToken(res.data.data.token);
                        localStorage.setItem('token', res.data.data.token);
                        // let tokenContract = new web3.eth.Contract(
                        //     tokenContractAbi,
                        //     process.env.REACT_APP_TOKEN_CONTRACT_ADDRESS
                        // );
                        // setTokenContract(tokenContract);
                        setIsWalletConnect(true);
                        await fetchBalance(
                            res.data.data.token,
                            signer,
                            await signer.getAddress()
                        );
                    })
                    .catch(async (err) => {
                        setWhitelistError(err.response.data.message);
                        setIsWhitelistError(true);
                    });
        } else {
            swal(
                'Wrong Network!',
                `Please switch to the ${process.env.REACT_APP_NETWORK}`,
                'warning'
            );
            disconnectWallet(false);
        }

        // Subscribe to accounts change
        provider.on('accountsChanged', async () => {
            await provider.disconnect();
            disconnectWallet(true);
        });

        // Subscribe to chainId change
        provider.on('chainChanged', async (id) => {
            if (`${id}` !== process.env.REACT_APP_CHAIN_ID) {
                await provider.disconnect();
                disconnectWallet(true);
            }
        });

        // Subscribe to session disconnection
        provider.on('disconnect', async () => {
            await provider.disconnect();
            disconnectWallet(true);
        });

        handleClose();
    };

    const connectToWallet = (key) => {
        switch (key) {
            case metamask:
                connectMetaMask();
                break;
            case walletconnect:
                connectWallectConnect();
                break;
            default:
                break;
        }
    };

    // const getCreditPlans = async () => {
    //     try {
    //         const smartContractInstance = getContract(web3Library);
    //         const response =
    //             await smartContractInstance.arcadeCreditBuyPlansAvailable();
    //         const plansObj = [];
    //         for (let i = 1; i <= response.toNumber(); i++) {
    //             const credit = await smartContractInstance.arcadeCreditBuyPlans(
    //                 i
    //             );
    //             plansObj.push({
    //                 arcadeCredits: Number(credit.arcadeCredits.toString()),
    //                 tamaRequired: Number(
    //                     ethers.utils.formatEther(credit.tamaRequired.toString())
    //                 ),
    //                 isActive: credit.isActive,
    //             });
    //         }
    //         setPlans(plansObj);
    //     } catch (ex) {
    //         console.log(ex);
    //
    //     }
    // };

    const buyCredits = async (index, tamaRequired, arcadeCredits) => {
        try {
            setTransactionLoading(true);
            openModal(false);
            const tokenSmartContractInstance = getTokenContract(web3Library);
            if (
                ethers.utils.formatEther(
                    (
                        await tokenSmartContractInstance.balanceOf(web3Account)
                    ).toString()
                ) > tamaRequired
            ) {
                const allowancwCheck =
                    await tokenSmartContractInstance.allowance(
                        web3Account,
                        contractAddress
                    );
                if (
                    ethers.utils.parseEther(allowancwCheck.toString()) >=
                    tamaRequired
                ) {
                    const myContract = getContract(web3Library, web3Account);
                    const overrides = {
                        gasLimit: 230000,
                    };
                    const response = await myContract.buyArcadeCredits(
                        index,
                        overrides
                    );
                    response
                        .wait(1)
                        .then(async (res) => {
                            if (res.status === 1) {
                                notify(
                                    'Buy credit successfully done',
                                    'success'
                                );
                                await fetchBalance(
                                    token,
                                    web3Library,
                                    web3Account
                                );
                                setTransactionLoading(false);
                            } else {
                                setTransactionLoading(false);
                            }
                        })
                        .catch(async (err) => {
                            notify('User denied transaction', 'error');
                            setTransactionLoading(false);
                            await fetchBalance(token, web3Library, web3Account);
                        });
                } else {
                    buyTama(index, tamaRequired, arcadeCredits);
                }
            } else {
                notify('Insufficient balance', 'error');
                await fetchBalance(token, web3Library, web3Account);
                setTransactionLoading(false);
            }
        } catch (ex) {
            notify('Transaction Failed', 'error');
            setTransactionLoading(false);
        }
    };

    const buyTama = async (index, tamaRequired, arcadeCredits) => {
        const tokenSmartContractInstance = getTokenContract(web3Library);
        const response = await tokenSmartContractInstance
            .approve(contractAddress, '2000000000000000000000000000')
            .then()
            .catch(async () => {
                notify('User denied transaction', 'error');
                await fetchBalance(token, web3Library, web3Account);
                setTransactionLoading(false);
            });
        response
            .wait(1)
            .then(async (res) => {
                if (res.status === 1) {
                    buyCredits(index, tamaRequired, arcadeCredits);
                }
            })
            .catch(async (err) => {
                notify('User denied transaction', 'error');
                await fetchBalance(token, web3Library, web3Account);
                setTransactionLoading(false);
            });
    };

    useEffect(() => {
        const getWalletDetails = async () => {
            if (!web3Library) {
                const etherProvider = new ethers.providers.Web3Provider(
                    window.ethereum.isMetaMask
                        ? window.ethereum
                        : window.ethereum.providers.find(
                              (prov) => prov.isMetaMask
                          )
                );
                const signer = etherProvider.getSigner();
                await signer
                    .getAddress()
                    .then((res) => {
                        setWeb3Account(res);
                        setWeb3Library(signer);
                        fetchBalance(token, signer, res);
                    })
                    .catch((err) => {
                        disconnectWallet(true);
                    });
            } else {
                fetchBalance(token, web3Library, web3Account);
            }
        };
        token && getWalletDetails();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    const fetchBalance = async (token, webLibrary, account) => {
        if (isWalletConnect) {
            const tokenInstance = new web3Provider.eth.Contract(
                tokenContractAbi,
                process.env.REACT_APP_TOKEN_CONTRACT_ADDRESS
            );
            tokenInstance &&
                setTamaBalance(
                    Web3.utils.fromWei(
                        (
                            await tokenInstance.methods
                                .balanceOf(account)
                                .call()
                        ).toString()
                    )
                );
        } else {
            const tokenSmartContractInstance = getTokenContract(webLibrary);
            setTamaBalance(
                Web3.utils.fromWei(
                    (
                        await tokenSmartContractInstance.balanceOf(account)
                    ).toString()
                )
            );
        }
        token &&
            creditBalance(token)
                .then((res) => {
                    setCredits(res.data.data.credits);
                    setUpdateTime(new Date());
                    setLoad(false);
                })
                .catch((err) => {
                    setLoad(false);
                });
    };

    const disconnectWallet = (reload) => {
        localStorage.clear();
        deactivate();
        localStorage.setItem('token', '');
        setWeb3Account('');
        setToken('');
        setTamaBalance('');
        setCredits('');
        reload && window.location.reload(true);
    };

    const { t } = useTranslation();
    return (
        <div>
            <BuyCreditModal
                showModal={showModal}
                setShowModal={setShowModal}
                credits={credits}
                buyCredits={buyCredits}
                tamaBalance={tamaBalance}
                token={token}
            />
            <WhitelistModal
                message={whitelistError}
                isError={isWhitelistError}
                onCloseModal={onCloseWhitelistModal}
            />
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    position: 'relative',
                    minHeight: '265px',
                    borderRadius: '20px',
                    marginBottom: '15px',
                    background: '#fff',
                    padding: '10px',
                }}
            >
                {token ? (
                    <div>
                        {transactionLoading ? (
                            <>
                                <p>{t('transaction_process')}...</p>
                                <img
                                    src={loading_icon}
                                    style={{ height: '50px' }}
                                    alt='logo'
                                />
                            </>
                        ) : (
                            <>
                                <RefreshIcon
                                    onClick={() => {
                                        fetchBalance(
                                            token,
                                            web3Library,
                                            web3Account
                                        );
                                        setLoad(true);
                                    }}
                                    id='credit_balance_update'
                                    className={load && 'loading'}
                                >
                                    <FontAwesomeIcon
                                        icon={faRefresh}
                                        size='2x'
                                        style={{ margin: 0, padding: 0 }}
                                    />
                                </RefreshIcon>
                                <H1
                                    style={{
                                        lineHeight: '25px',
                                    }}
                                >
                                    {t('credit')}
                                </H1>
                                <CommonText>
                                    {translateNum(credits)} {t('credit_left')}
                                </CommonText>
                                <CommonText>
                                    {translateNum(tamaBalance)} {t('tama')}{' '}
                                    {t('tokens')}
                                </CommonText>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        flexWrap: 'wrap',
                                    }}
                                >
                                    <Button
                                        id='show_plans_popup'
                                        style={{
                                            background: '#F8D760',
                                            width: '40%',
                                            minWidth: '115px',
                                        }}
                                        onClick={() => {
                                            // getCreditPlans();
                                            openModal(true);
                                        }}
                                    >
                                        {t('buy_now')}
                                    </Button>
                                    <Button
                                        style={{
                                            background: 'red',
                                            width: '40%',
                                            minWidth: '115px',
                                        }}
                                        onClick={() => disconnectWallet(true)}
                                    >
                                        {t('disconnect')}
                                    </Button>
                                </div>
                                <p style={{ margin: 10, lineHeight: '20px' }}>
                                    {t('last_update')}{' '}
                                    {moment(updateTime).format(
                                        'DD/MM/YY HH:mm'
                                    )}
                                </p>
                            </>
                        )}
                    </div>
                ) : (
                    <div>
                        <Button
                            onClick={handleOpen}
                            style={{
                                background: '#F8D760',
                                width: '200px',
                                display: 'block',
                            }}
                        >
                            {t('connect_wallet')}
                        </Button>
                    </div>
                )}
                <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                >
                    <Box sx={style}>
                        <CloseButton onClick={handleClose}>
                            <img
                                src={Close}
                                style={{ height: 15 }}
                                alt='close'
                            />
                        </CloseButton>
                        <H1 className='connect-wallet'>
                            {t('connect_wallet_lable')}
                        </H1>
                        <div>
                            {walletOption.map((option, index) =>
                                isMobile ? (
                                    option.isMobileVisible && (
                                        <Li
                                            key={`wlt${index}`}
                                            onClick={() =>
                                                connectToWallet(option.key)
                                            }
                                        >
                                            <Wrapper>
                                                <img
                                                    src={option.image}
                                                    alt={option.title}
                                                />
                                                <p>{t(`${option.title}`)}</p>
                                            </Wrapper>
                                            <span>{option.subtext}</span>
                                        </Li>
                                    )
                                ) : (
                                    <Li
                                        key={`wlt${index}`}
                                        onClick={() =>
                                            connectToWallet(option.key)
                                        }
                                    >
                                        <Wrapper>
                                            <img
                                                src={option.image}
                                                alt={option.title}
                                            />
                                            <p>{t(`${option.title}`)}</p>
                                        </Wrapper>
                                        <span>{option.subtext}</span>
                                    </Li>
                                )
                            )}
                        </div>
                    </Box>
                </Modal>
            </div>
        </div>
    );
}
export default CreditBalance;
